export default "__VITE_ASSET__c7b29144__"